import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { waLink } from "@/lib/brand";

const LINKS = [
  { href: "#topo", label: "Início" },
  { href: "#planos", label: "Planos" },
  { href: "#produtos", label: "Produtos" },
  { href: "/revendedor", label: "Seja um revendedor", page: true },
  { href: "/idealize", label: "Idealize", page: true },
];

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "-");

export const Nav = ({ base = "" }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header data-testid="site-nav" className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled || open ? "bg-[#07080f]/80 backdrop-blur-xl border-b border-white/10" : "border-b border-transparent"}`}>
      <nav className="mx-auto flex h-16 sm:h-20 max-w-[1400px] items-center justify-between px-5 sm:px-10">
        <a href={base ? "/" : "#topo"} data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/brand/speedmax-icon.png" alt="Speed Max" className="h-8 w-8 sm:h-9 sm:w-9" />
          <span className="font-display text-sm sm:text-base font-bold tracking-tight">SPEED MAX</span>
        </a>
        <ul className="hidden md:flex items-center gap-6 text-[13px] text-zinc-300">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a data-testid={`nav-link-${slug(l.label)}`} href={l.page ? l.href : base + l.href} className="relative py-2 transition-colors hover:text-white after:absolute after:left-0 after:-bottom-0.5 after:h-px after:w-full after:origin-left after:scale-x-0 after:bg-cyan-300 after:transition-transform after:duration-300 hover:after:scale-x-100">{l.label}</a>
            </li>
          ))}
        </ul>
        <div className="flex items-center gap-2">
          <a data-testid="nav-whatsapp-btn" href={waLink("Olá! Vim pelo site da Speed Max e gostaria de atendimento.")} target="_blank" rel="noreferrer" className="hidden sm:inline-flex rounded-full bg-white px-4 py-2 text-[13px] font-semibold text-[#07080f] transition-transform duration-300 hover:-translate-y-0.5">Fale conosco</a>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="md:hidden p-2 text-white" aria-label="Menu">{open ? <X size={22} /> : <Menu size={22} />}</button>
        </div>
      </nav>
      {open && (
        <ul data-testid="nav-mobile-menu" className="md:hidden flex flex-col gap-1 px-5 pb-6">
          {LINKS.map((l) => (
            <li key={l.href}><a data-testid={`nav-mobile-link-${slug(l.label)}`} href={l.page ? l.href : base + l.href} onClick={() => setOpen(false)} className="block py-2.5 font-display text-lg border-b border-white/10">{l.label}</a></li>
          ))}
        </ul>
      )}
    </header>
  );
};
